import React, { useEffect, useState } from 'react';
import { LineChart } from '@mui/x-charts/LineChart';
import { BarChart } from '@mui/x-charts/BarChart';
import Paper from '@mui/material/Paper';
import { Dialog, useTheme } from '@mui/material';
import DailyResults from '../Popups/DailyResults';
import TodaysStats from '../../types/api/TodaysStats';
import KPICard from '../Dashboard/KPICard';
import dayjs from 'dayjs';

interface Props { dashboardInfos?: TodaysStats }

const TabPrevisions: React.FC<Props> = ({ dashboardInfos }) => {
  const theme = useTheme();
  const [dailyResultsPopup, setDailyResultsPopup] = useState(false);
  const [forecastNext14Days, setForecastNext14Days] = useState<{ label: string; value: number }[]>([]);

  const total = (dashboardInfos?.DailyForecast?.noonPerformance ?? 0) + (dashboardInfos?.DailyForecast?.eveningPerformance ?? 0);


  useEffect(() => {
    // Générer les prévisions pour les 14 prochains jours (J+1 à J+14) à partir du backend
    if (Array.isArray(dashboardInfos?.DailyForecasts) && (dashboardInfos?.DailyForecasts?.length ?? 0) > 0) {
      const forecasts = dashboardInfos!.DailyForecasts.map((forecast) => {
        const date = dayjs()
          .year(forecast.year)
          .month(forecast.month)
          .date(forecast.dayNumber)
          .locale('fr');
        const label = date.format('ddd DD/MM');
        return { label, value: (forecast.noonPerformance ?? 0) + (forecast.eveningPerformance ?? 0), date: date };
      });
      setForecastNext14Days(forecasts);
    } else {
      setForecastNext14Days([]);
    }
  }, [dashboardInfos]);

  // Préparation des données pour le BarChart J+14 (midi/soir)
  const barLabelsJ14 = (dashboardInfos?.DailyForecasts ?? []).map(forecast => {
    const date = dayjs()
      .year(forecast.year)
      .month(forecast.month)
      .date(forecast.dayNumber)
      .locale('fr');
    return date.format('ddd DD/MM');
  });
  const barDataNoonJ14 = (dashboardInfos?.DailyForecasts ?? []).map(forecast => forecast.noonPerformance ?? 0);
  const barDataEveningJ14 = (dashboardInfos?.DailyForecasts ?? []).map(forecast => forecast.eveningPerformance ?? 0);

  return (
    <div className="space-y-6">
      {/* KPI Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <KPICard title="Couverts total (prévision)" value={total} comparison="Aujourd'hui" />
        <KPICard title="Service midi (prévision)" value={dashboardInfos?.DailyForecast?.noonPerformance ?? 0} comparison="couverts" />
        <KPICard title="Service soir (prévision)" value={dashboardInfos?.DailyForecast?.eveningPerformance ?? 0} comparison="couverts" />
        <KPICard title="Masse salariale prévue" value={`${(dashboardInfos?.payroll ?? 0).toFixed(2)} €`} comparison="Aujourd'hui" />
      </div>




      {/* Charts */}
      <div className="flex flex-col lg:flex-row gap-6">
        <Paper elevation={3} style={{ flex: 1, padding: '20px', minHeight: '450px' }} sx={{backgroundColor: 'background.paper', color: 'text.primary'}}>
          <span className='text-2xl font-bold block mb-2'>Prévisions couverts jusqu'à J+14</span>
          <LineChart
            xAxis={[{
              scaleType: 'band',
              dataKey: 'label',
              data: forecastNext14Days.map((item) => item.label),
              tickLabelPlacement: 'middle',
              tickPlacement: 'middle',
              
            }]}
            series={[{ color : '#C8A059', data: forecastNext14Days.map((item) => item.value) }]}
            width={700}
            height={400}
            slotProps={{
              // @ts-expect-error MUI X Charts slotProps.tooltip n'est pas typé mais fonctionne à l'exécution
              tooltip: {
                trigger: 'item',
                content: (params: any) => {
                  const idx = params?.dataIndex ?? 0;
                  if (!Array.isArray(dashboardInfos?.DailyForecasts) || !dashboardInfos?.DailyForecasts[idx] || !forecastNext14Days[idx]) return null;
                  const forecast = dashboardInfos.DailyForecasts[idx];
                  const label = forecastNext14Days[idx].label;
                  return (
                    <div style={{ padding: 8, background: theme.palette.background.paper, color: theme.palette.text.primary, borderRadius: 6, minWidth: 120 }}>
                      <div><b>{label}</b></div>
                      <div>Midi : <b>{forecast.noonPerformance}</b></div>
                      <div>Soir : <b>{forecast.eveningPerformance}</b></div>
                      <div>Total : <b>{(forecast.noonPerformance ?? 0) + (forecast.eveningPerformance ?? 0)}</b></div>
                    </div>
                  );
                }
              }
            }}
          />
        </Paper>

        <Paper elevation={3} style={{ flex: 1, padding: '20px', minHeight: '450px' }} sx={{backgroundColor: 'background.paper', color: 'text.primary'}}> 
          <span className='text-2xl font-bold block mb-2'>Moyenne couverts midi et soir (J+14)</span>
          <BarChart
            xAxis={[{ scaleType: 'band', data: barLabelsJ14, tickLabelPlacement: 'middle', tickPlacement: 'middle'  }]}
            series={[
              
              { data: barDataNoonJ14, label: 'Midi',color: '#C8A059' },
              { data: barDataEveningJ14, label: 'Soir', color :'#817052'  }
            ]}
            width={700}
            height={400}
            barLabel="value"
          />
        </Paper>
      </div>

      <Dialog open={dailyResultsPopup} maxWidth='lg'>
        <DailyResults 
          mode='add'
          baseValue={dashboardInfos?.DailyResult}
          no={()=>{setDailyResultsPopup(false)}} 
          yes={()=>setDailyResultsPopup(false)} 
        />
      </Dialog>
    </div>
  );
};

export default TabPrevisions;